<app-layout>
    <div class="main">
        <div class="header">
            <app-titulo>Blacklist</app-titulo>
            <div class="header-buttons">
                <app-botao type="primario" class="button" text="Adicionar Restrição" icon="assets/add.svg"
                    *ngIf="solicitarAgendamento" (click)="navegarFormulario()"></app-botao>
                <!-- <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
                    (click)="downloadExcel()"></app-botao> -->
            </div>
        </div>
        <div class="desktop grid-outline">
            <div class="grid-header header-filters">
                <div class="intern-title">
                    Bloqueios e Supervisões Ativos
                </div>

                <form [formGroup]="form" class="filters-inline">
                    <app-input type="dropdown" label="Categoria" name="NU_IDNT_CHVE" formControlName="NU_IDNT_CHVE"
                        placeholder="Selecione" [selectData]="identificadorOptions" [coerceValue]="'number'" />

                    <app-input label="Situação" placeholder="Selecione" type="dropdown" formControlName="NU_TIPO_BLOQ"
                        [coerceValue]="'number'" width="180px" [selectData]="situacaoOptions">
                    </app-input>

                    <app-input label="Expira em" type="date" formControlName="DT_DURC_BLOQ" width="150px">
                    </app-input>
                </form>
            </div>
            <app-loader [isLoading]="isLoading"></app-loader>
            <app-tabela *ngIf="!isLoading" [data]="tableData" [columns]="tableColumns"></app-tabela>
        </div>
    </div>
    <div class="mobile">
        <form [formGroup]="form" class="table-filters">
            <app-input label="Categoria" placeholder="Digite" formControlName="NU_IDNT_CHVE" width="160px">
            </app-input>

            <app-input label="Situação" placeholder="Digite" formControlName="NU_TIPO_BLOQ" width="180px">
            </app-input>

            <app-input label="Expira em" type="date" formControlName="DT_DURC_BLOQ" width="150px">
            </app-input>
        </form>
        <app-card *ngIf="!isLoading" [data]="tableData" [rows]="tableColumns" [expand]="true" />
    </div>
    <app-subtitulo *ngIf="!tableData.length">Nenhum Bloqueio ou Supervisão encontrado.</app-subtitulo>
    <div class="paginacao">
        <app-paginacao *ngIf="tableData?.length" [pages]="maxPages"
            (selectedPage)="mudarPagina($event)"></app-paginacao>
    </div>
    <div class="iframe-container"></div>
</app-layout>

<!-- MODAL HISTÓRICO -->
<div class="modal-overlay" *ngIf="isHistoricoOpen" (click)="isHistoricoOpen = false">
</div>

@if (isHistoricoOpen) {
<div class="modal" role="dialog" aria-modal="true">
    <div class="modal-header">
        <button class="modal-close" (click)="isHistoricoOpen = false" aria-label="Fechar">
            ×
        </button>
        <h2>Histórico</h2>
    </div>

    <div class="modal-body">
        <app-loader [isLoading]="historicoLoading"></app-loader>

        <app-tabela *ngIf="!historicoLoading" [data]="historicoRows" [columns]="historicoColumns">
        </app-tabela>
    </div>
</div>
}